import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import Placeholder from 'Components/Placeholder';
import Leaderboard from 'Edits/Leaderboard';

registerBlockType('eformv4/form-leaderboard', {
	title: __('Form Leaderboard - eForm', 'ipt_fsqm'),
	icon: 'welcome-widgets-menus',
	category: 'eform-v4',
	attributes: {
		...eFormGTB.attributes['form-leaderboard'],
	},

	edit({ attributes, className, setAttributes }) {
		const title = __('Form Leaderboard', 'ipt_fsqm');
		const message = __(
			'A leaderboard to showcase the ranking of a form',
			'ipt_fsqm'
		);

		return (
			<Placeholder className={className} title={title} message={message}>
				<Leaderboard {...{ attributes, setAttributes }} />
			</Placeholder>
		);
	},

	save() {
		return null;
	},
});
